import { render, staticRenderFns } from "./SponsorshipRequestModal.vue?vue&type=template&id=de1512f8&scoped=true&"
import script from "./SponsorshipRequestModal.vue?vue&type=script&lang=js&"
export * from "./SponsorshipRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./SponsorshipRequestModal.vue?vue&type=style&index=0&id=de1512f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1512f8",
  null
  
)

export default component.exports